import React, { PropTypes } from 'react';
import fetch from 'utils/fetch';
import moment from 'moment';

const NoItem = () => (
  <div className="ui info message">Aucune maintenance programmée</div>
);

const eventDate = event =>
  moment(event.expired_at).format('DD/MM/YYYY à HH:mm');

class EventItem extends React.Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete() {
    const { event } = this.props;
    this.props.onDelete(event.id);
  }

  render() {
    const { event } = this.props;
    return (
      <tr>
        <td className="collapsing">
          <button className="ui red tiny icon button" onClick={this.onDelete}>
            <i className="remove icon" />
          </button>
        </td>
        <td>{eventDate(event)}</td>
        <td>{event.content}</td>
      </tr>
    );
  }
}

export default class MaintenanceList extends React.Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isFetching: true,
    };

    this.deleteEvent = this.deleteEvent.bind(this);
  }

  componentWillMount() {
    const { token } = this.props;

    fetch('/admin/maintenances', {
      headers: {
        'X-Allow-Admin': token,
      },
    })
      .then(r => r.json())
      .then(events =>
        this.setState({
          isFetching: false,
          events,
        })
      );
  }

  deleteEvent(id) {
    const { token } = this.props;

    fetch(`/admin/maintenances/${id}`, {
      method: 'DELETE',
      headers: {
        'X-Allow-Admin': token,
      },
    }).then(() => window.location.reload(true));
  }

  render() {
    const { isFetching, events } = this.state;
    if (isFetching) {
      return (
        <div className="ui active inverted dimmer">
          <div className="ui text loader">Loading</div>
        </div>
      );
    }

    if (events.length) {
      return (
        <table className="ui very basic table">
          <thead className="full-width">
            <tr>
              <th />
              <th className="five wide">Date</th>
              <th>Contenu</th>
            </tr>
          </thead>
          <tbody>
            {events.map(e => (
              <EventItem key={e.id} event={e} onDelete={this.deleteEvent} />
            ))}
          </tbody>
        </table>
      );
    }

    return <NoItem />;
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/MaintenanceList.js